/** Cohort sidebar, table shell, main analyzer column, and grid wrappers. */
import { cohortAnalyzerHiddenScrollbarStyles } from './cohortAnalyzerScrollbarStyles';

export const cohortAnalyzerLayoutStyles = (theme) => ({
  leftSideAnalyzer: {
    minWidth: 274,
    maxWidth: 274,
    height: 588,
    marginTop: 40,
    overflow: 'hidden',
    borderRadius: ' 0px 35px 35px 0px',
    border: '4px solid #4E8191',
    borderLeft: 'none',
    backgroundColor: 'rgba(255, 255, 255, 0.95)',
    backdropFilter: 'blur(10px)',
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
  },
  leftSideAnalyzerChild: {
    height: '90%',
    overflowY: 'scroll',
    '&::-webkit-scrollbar': {
      width: '2px',
    },
    '&::-webkit-scrollbar-thumb': {
      width: '2px',
      backgroundColor: '#003F74',
    },
    '&::-webkit-scrollbar-track': {
      background: '#4E8191',
    },
  },
  cohortSelectionChild: {
    display: 'flex',
    alignItems: 'flex-start',
    width: '100%',
    '& span': {
      fontSize: 12,
      fontFamily: 'Poppins',
      fontWeight: 500,
    },
  },
  cohortChildSelected: {
    width: '100%',
    height: 28,
    display: 'flex',
    marginBottom: 2,
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  CohortChild: {
    background: 'rgba(181, 221, 229, 0.4)',
    width: '100%',
    height: 28,
    display: 'flex',
    marginBottom: 2,
    alignItems: 'center',
    justifyContent: 'space-between',
    '&:nth-child(even)': {
      background: 'rgba(165, 194, 200, 0.4)',
    },
    '& span': {
      color: 'black',
    },
    '& div img': {
      opacity: 1,
    },
  },
  CohortChildOpacity: {
    background: 'rgba(181, 221, 229, 0.2)',
    width: '100%',
    height: 28,
    display: 'flex',
    marginBottom: 2,
    alignItems: 'center',
    justifyContent: 'space-between',
    '&:nth-child(even)': {
      background: 'rgba(165, 194, 200, 0.2)',
    },
    '& span': {
      color: 'black',
    },
    '& div img': {
      opacity: 1,
    },
  },
  CohortChildDisabled: {
    background: '#E2F1F5',
    width: '100%',
    height: 28,
    display: 'flex',
    marginBottom: 2,
    alignItems: 'center',
    opacity: 0.3,
    pointerEvents: 'auto',
    justifyContent: 'space-between',
    '&:nth-child(even)': {
      background: 'rgba(165, 194, 200, 0.4)',
    },
    '& span': {
      color: 'black',
    },
    '& div img': {
      opacity: 1,
    },
  },
  sideHeader: {
    height: 125,
    fontFamily: 'Poppins',
    fontSize: 18.5,
    fontWeight: 500,
    color: '#000',
    letterSpacing: '-0.02em',
    textAlign: 'left',
    width: '100%',
    display: 'flex',
    paddingTop: 20,
    flexDirection: 'column',
    alignSelf: 'center',
    margin: 'auto',
    borderBottom: '1px solid #B0B0B0',
    paddingLeft: 20,
    justifyContent: 'flex-start',
    justifyItems: 'flex-start',
    '& img': {
      marginRight: 6.5,
    },
    '& p': {
      fontFamily: 'Open Sans',
      fontSize: 15,
      fontWeight: 400,
      color: 'black',
      padding: 0,
    },
  },
  sortSection: {
    height: 31,
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    justifyContent: 'space-between',
    paddingLeft: 20,
    backgroundColor: '#F1F1F1',
    '& p': {
      fontSize: 9,
    },
  },
  cohortCountSection: {
    fontFamily: 'Poppins',
    fontSize: 15,
    fontWeight: 500,
    letterSpacing: -0.02,
    textAlign: 'left',
    minHeight: 58.94,
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    width: '100%',
    paddingBottom: 16,
    paddingTop: 16,
    paddingRight: 15,
    [theme.breakpoints.down('lg')]: {
      width: '100%',
    },
  },
  tableSectionOuterContainer: {
    width: '100%',
    border: '1px solid #679AAA',
    borderRadius: 10,
    overflow: 'hidden',
    backgroundColor: 'rgba(255, 255, 255, 0.95)',
    backdropFilter: 'blur(10px)',
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
  },
  rightSideAnalyzer: {
    width: '100%',
    maxWidth: '100%',
    flex: 1,
    minWidth: 0,
    minHeight: 600,
    borderRadius: '35px',
    border: '4px solid #4E8191',
    margin: 100,
    marginLeft: 33,
    marginRight: 33,
    marginTop: 40,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    overflowX: 'hidden',
    overflowY: 'auto',
    ...cohortAnalyzerHiddenScrollbarStyles,
    backgroundColor: 'rgba(255, 255, 255, 0.95)',
    backdropFilter: 'blur(10px)',
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
    [theme.breakpoints.down('lg')]: {
      alignItems: 'flex-start',
      overflowX: 'hidden',
      overflowY: 'auto',
      ...cohortAnalyzerHiddenScrollbarStyles,
      padding: '0 0 0 0',
      height: '100%',
      minWidth: '0',
    },
  },
  gridLayoutContainer: {
    flex: 1,
    minWidth: 0,
    minHeight: 600,
    width: '100%',
    height: '100%',
  },
  gridItemWrapper: {
    overflow: 'auto',
    minHeight: 0,
    ...cohortAnalyzerHiddenScrollbarStyles,
    background: 'rgba(255, 255, 255, 0.95)',
    border: '1px solid #679AAA',
    borderRadius: 10,
    padding: 8,
  },
  rightSideAnalyzerOuterContainer: {
    display: 'flex',
    marginBottom: 45,
    justifyContent: 'flex-start',
    width: '100%',
    marginTop: '16px',
    gap: 26,
    backgroundColor: '#EFF5FB',
    [theme.breakpoints.down('lg')]: {
      flexDirection: 'column',
      gap: 0,
      marginTop: '20px',
    },
  },
});
